
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.354 7.173l-1.796-.599.846-1.691a.95.95 0 00-.18-1.083L15.2 1.777a.95.95 0 00-1.092-.181l-1.692.845-.598-1.795A.95.95 0 0010.925 0h-2.85a.95.95 0 00-.902.646l-.599 1.796-1.691-.846a.95.95 0 00-1.083.18L1.777 3.8a.95.95 0 00-.181 1.093l.845 1.69-1.795.599A.95.95 0 000 8.075v2.85a.95.95 0 00.646.902l1.796.599-.846 1.691a.95.95 0 00.18 1.083L3.8 17.224a.95.95 0 001.093.18l1.69-.846.599 1.796a.95.95 0 00.902.646h2.85a.95.95 0 00.903-.646l.598-1.796 1.691.846a.951.951 0 001.074-.18l2.024-2.024a.95.95 0 00.18-1.092l-.846-1.692 1.796-.598a.95.95 0 00.646-.893v-2.85a.95.95 0 00-.646-.902zM17.1 10.24l-1.14.38a1.9 1.9 0 00-1.102 2.679l.541 1.083-1.044 1.045-1.055-.57a1.9 1.9 0 00-2.65 1.102l-.38 1.14H8.759l-.38-1.14A1.9 1.9 0 005.7 14.858l-1.083.541-1.045-1.044.57-1.055a1.9 1.9 0 00-1.102-2.679l-1.14-.38V8.759l1.14-.38A1.9 1.9 0 004.142 5.7L3.6 4.646 4.646 3.6l1.054.542A1.9 1.9 0 008.379 3.04l.38-1.14h1.482l.38 1.14A1.9 1.9 0 0013.3 4.142l1.083-.542 1.045 1.046-.57 1.054a1.9 1.9 0 001.102 2.65l1.14.38v1.511zM9.5 5.7a3.8 3.8 0 100 7.6 3.8 3.8 0 000-7.6zm0 5.7a1.9 1.9 0 110-3.8 1.9 1.9 0 010 3.8z"}})])
          )
        }
      }
    